import * as excel from 'exceljs';
import { changeDateFormat, workoutDetailsInterface } from "../app/consts";


export const createExcel = (currentWorkout: workoutDetailsInterface) => {
    const workout = { ...currentWorkout }
    workout.participantsList = currentWorkout.participantsList.filter((value) => value.isActive !== false)

    const date = workout?.date as string
    const workoutType = workout?.type?.name as string

    const wk = new excel.Workbook();
    const sheet = wk.addWorksheet("אימון", {
        pageSetup: {
            orientation: workout?.fullForm ? 'landscape' : 'portrait',
            paperSize: 9,
            fitToPage: true,
            margins: workout?.fullForm ? {
                bottom: 0,
                top: 0,
                left: 0,
                right: 0,
                footer: 0,
                header: 0
            } : undefined
        },
        views: [{ rightToLeft: true }],
    });

    workout?.fullForm ? sheet.mergeCells('A1', 'O1') : sheet.mergeCells('A1', 'G1');
    sheet.getCell('A1').value = `אימון ${workoutType} - ${changeDateFormat(workout?.date as string)}, ${workout?.time.slice(0, -3)}, ${workout?.location} - מדריך: ${workout?.instructor?.fullName === null ? "לא משובץ" : workout?.instructor?.fullName}`
    sheet.getCell('A1').font = { size: workout?.fullForm ? 48 : 22 }
    sheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' }
    workout?.fullForm ?
        sheet.getRow(2).values = ["מספר סידורי", "שם מלא", "מספר טלפון", "מספר רשיון נשק", "תוקף רשיון", "סוג אקדח", "מספר נשק", "קליבר", "שעת כניסה", "חתימה", "תחמושת", "שעת יציאה", "הערות מתאמן", "סטטוס תשלום", "הערות מנהל"]
        :
        sheet.getRow(2).values = ["מספר סידורי", "שם מלא", "מספר טלפון", "קליבר", "הערות מתאמן", "סטטוס תשלום", "הערות מנהל"]


    sheet.getRow(2).font = { size: 16 }
    sheet.getRow(2).eachCell((cell) => {
        cell.border = {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } }
        };
        cell.alignment = { horizontal: "center", vertical: "middle" }
    });

    workout?.fullForm ?
        sheet.columns = [
            {
                key: "id",
                width: 15,
            },
            {
                key: "fullName",
                width: 20,
            },
            {
                key: "phoneNum",
                width: 20,
            },
            {
                key: "licenseNumber",
                width: 20,
            },
            {
                key: "licenseExpiryDate",
                width: 20,
            },
            {
                key: "pistolType",
                width: 20,
            },
            {
                key: "pistolId",
                width: 20,
            },
            {
                key: "caliber",
                width: 9,
            },
            {
                key: "entryTime",
                width: 20,
            },
            {
                key: "signature",
                width: 20,
            },
            {
                key: "ammunition",
                width: 15,
            },
            {
                key: "exitTime",
                width: 20,
            },
            {
                key: "notes",
                width: 20,
            },
            {
                key: "payment",
                width: 15,
            },
            {
                key: "managerNotes",
                width: 20,
            }

        ]
        :
        sheet.columns = [
            {
                key: "id",
                width: 15,
            },
            {
                key: "fullName",
                width: 20,
            },
            {
                key: "phoneNum",
                width: 20,
            },
            {
                key: "caliber",
                width: 9,
            },
            {
                key: "notes",
                width: 20,
            },
            {
                key: "payment",
                width: 20,
            },
            {
                key: "managerNotes",
                width: 20,
            }
        ]

    if (workout?.fullForm as boolean === true) {
        for (let i = 0; i < 5; i++) {
            sheet.addRow({}, "i+")
        }
    }

    workout?.participantsList?.forEach((row, index) => {
        let data = {}
        data = {
            ...data,
            id: index + 1,
            fullName: row.firstName + " " + row.lastName,
            phoneNum: row.phoneNum,
            caliber: row.caliber,
            notes: row.notes,
            payment: row.isPaid ? `שולם - ${row.paymentConfirmation}` : "",
            managerNotes: row.adminNotes?.map((note) => note.content).join("\r\n"),
        }
        if (workout.fullForm) {
            data = {
                ...data,
                licenseNumber: row.licenseNumber,
                licenseExpiryDate: changeDateFormat(row.licenseExpiryDate),
                pistolType: row.pistolType,
                pistolId: row.pistolNumber,
                entryTime: "",
                signature: "",
                ammunition: "",
                exitTime: "",
            }
        }

        sheet.addRow(data)
    })


    sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
            row.getCell(colNumber).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });
    });

    if (Number(workout?.price) === 0) {
        let column_to_remove = -1
        for (let i = 1; i <= Number(sheet.getRow(2).values.length) ; i++) {
            if (sheet.getRow(2).values[i] === "סטטוס תשלום") {
                column_to_remove = i;
            }
        }
        workout?.fullForm ? sheet.unMergeCells('A1', 'O1') : sheet.unMergeCells('A1', 'G1');
        sheet.spliceColumns(column_to_remove,1)
        workout?.fullForm ? sheet.mergeCells('A1', 'N1') : sheet.mergeCells('A1', 'F1');
    }

    wk.xlsx.writeBuffer().then(function (workout) {
        const blob = new Blob([workout], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `אימון ${workoutType} - ${changeDateFormat(date)}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    });
}